import { Check, Circle } from "lucide-react"

import type { TaskFeedback } from "@/types/taskFeedbackTypes"
import { getDir } from "@/utils/helpers"
import avatar from "/assets/images/avatar.png"

import { useTranslation } from "react-i18next"
import style from "./TicketsStyle.module.css"

export default function FeedbackNoteMessage({
  user,
  ele,
}: {
  ele: TaskFeedback
  user: string
}) {
  const { t } = useTranslation()

  return (
    <div className={`d-flex gap-3 flex-grow-1 flex-column align-items-start`}>
      <div className={`d-flex gap-3 w-100`}>
        {user === "agent" && (
          <div className={style["img_con"]}>
            <img src={avatar} alt="Agent Avatar" />
          </div>
        )}
        <div
          className={` ${style["message"]} ${
            user === "user" ? style["user"] : style["agent"]
          }`}
          dir={getDir(ele?.content)}
        >
          {Number(ele?.type) == 1 ? (
            <div className="d-flex flex-column align-items-center gap-3 flex-1">
              <audio style={{ maxWidth: "100%" }} controls>
                <source
                  src={
                    typeof ele.content === "string"
                      ? ele.content
                      : URL.createObjectURL(ele.content as any) // eslint-disable-line @typescript-eslint/no-explicit-any
                  }
                  type="audio/wav"
                />
                {t("audioRecorder.noSupport")}
              </audio>
            </div>
          ) : Number(ele?.type) == 2 ? (
            <div className="d-flex flex-column justify-content-center gap-3">
              <img
                src={
                  typeof ele.content === "string"
                    ? ele.content
                    : URL.createObjectURL(ele.content as any) // eslint-disable-line @typescript-eslint/no-explicit-any
                }
                alt="Uploaded Image"
                style={{
                  maxWidth: "100%",
                  maxHeight: "200px",
                  borderRadius: "5px",
                }}
              />
            </div>
          ) : (
            <span>{ele?.content}</span>
          )}
        </div>
      </div>

      {/* ✅ Created Info + Read Status */}
      <div className="text-muted small mt-1 text-end pe-5 d-flex gap-3 align-items-center">
        {ele?.created_by && <div>{ele.created_by}</div>}
        <div>{ele.created_at}</div>
        {ele?.read === 1 ? (
          <Check size={14} color="green" />
        ) : (
          <Circle size={10} color="blue" />
        )}
      </div>
    </div>
  )
}
